import { WhitelistAddressStepType } from 'data/types'

import * as AT from './actionTypes'

export type SubmitWhitelistAddressActionType = {
  payload: { readonly step: WhitelistAddressStepType }
  type: typeof AT.WHITELIST_SUBMIT
}

export type WhitelistAddressActionType =
  | { type: typeof AT.WHITELIST_GET_STATUS }
  | SubmitWhitelistAddressActionType

const getStatus = (): WhitelistAddressActionType => ({
  type: AT.WHITELIST_GET_STATUS
})

const submit = (step: WhitelistAddressStepType): WhitelistAddressActionType => ({
  payload: { step },
  type: AT.WHITELIST_SUBMIT
})

export default { getStatus, submit }
